import { lazy } from 'react'

// Sonar
export const SonarPage = lazy(() => import('@/features/sonar/pages/SonarPage'))
export const SonarListDetailPage = lazy(() =>
  import('@/features/sonar/pages/SonarListDetailPage')
)
export const SonarRuleDetailPage = lazy(() =>
  import('@/features/sonar/pages/SonarRuleDetailPage')
)
export const VAMPPage = lazy(() => import('@/features/sonar/pages/VAMPPage'))
export const FraudScheduleDetailPage = lazy(() =>
  import('@/features/sonar/pages/FraudScheduleDetailPage')
)
export const SonarSettingsPage = lazy(() =>
  import('@/features/sonar/pages/SonarSettingsPage').then((m) => ({
    default: m.SonarSettingsPage,
  }))
)

// Sonar Rule Wizard
export const RuleCreateWizardPage = lazy(() =>
  import('@/features/sonar/pages/RuleCreateWizardPage')
)

// Risk Scorecards
export const RiskScorecardsPage = lazy(() =>
  import('@/features/risk-scorecards/pages/RiskScorecardsPage')
)
export const CreateScorecardWizardPage = lazy(() =>
  import('@/features/risk-scorecards/pages/CreateScorecardWizardPage').then((m) => ({
    default: m.CreateScorecardWizardPage,
  }))
)
